/*!
 * Counter from input
 */

const parentWrap = '.counter';

let wrap;

let btnMinus = '.minus';

let btnPlus = '.plus';

let $input;

/**
 * Get val
 * @param e
 * @returns {number}
 */
let getInputVal = (e) => {
    let $parent = $(e.currentTarget).closest(parentWrap);

    $input = $parent.find('input');

    return +$input.val();
};

/**
 * Update counter
 * @param e
 * @param itemDirection
 */
let updateCounter = (e, itemDirection) => {
    let inputVal = getInputVal(e);

    if (isNaN(inputVal) || inputVal === 0 || inputVal === 1 && itemDirection === -1) {
        $input.val(1);
    } else {
        $input.val(inputVal + itemDirection);
    }
};

/**
 * Sets listens for events
 */
let setUpListens = () => {
    $(wrap).on('click', btnMinus, (e) => {
        e.preventDefault();
        updateCounter(e, -1);
    });

    $(wrap).on('click', btnPlus, (e) => {
        e.preventDefault();
        updateCounter(e, 1);
    });

    $(wrap).on('keyup', 'input', (e) => {
        updateCounter(e, 0);
    });
};

/**
 * Init
 */
let init = (wrapBtn, btnDown, btnTop) => {
    if ($(wrapBtn).length) {
        wrap = wrapBtn;
        btnMinus = btnDown ? btnDown : btnMinus;
        btnPlus = btnTop ? btnTop : btnPlus;

        setUpListens();
    }
};

export {init as initCounter};
